export default __webpack_public_path__ + "static/cog-logo-d32b589519f06101e841b120bcaa7289.png";